<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                  Label Text Input                                    │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->
<template>
    <div :class="cssClasses">
        <span v-if="required" class="required-marker"></span>
        <input :type="type"
               :name="name"
               :id="id"
               ref="input"
               :value="inputValue"
               :autocomplete="autocomplete"
               :maxlength="maxlength"
               :required="required"
               @keyup="$emit('change')"
               @keyup.enter="$emit('submit')"
               @input.prevent="onValueChange($event.target.value)" />
        <label :for="id" ><slot /></label>
        <slot name="addendum" />
    </div>
</template>
<style lang="less" scoped>
    .labeled-text-input {
        display: inline-block;
        margin-top: 1em;
        position: relative;
    }

        .labeled-text-input label {
            display: inline-block;
            line-height: 1.3;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            user-select: none;

            vertical-align: baseline;
            cursor: text;
            position: absolute;
            top: 0;
            right: 4px;
            left: 4px; /* 2px padding + 2px border */
            z-index: 1;
            transition-property: font-size, top, right, left;
            transition-duration: .25s;
            transition-timing-function: ease-in-out;
        }

        .labeled-text-input input {
            width: 100%;
        }

        .labeled-text-input input:-webkit-autofill + label,
        .labeled-text-input.filled label,
        .labeled-text-input:focus-within label {
            font-size: .75em;
            font-weight: 500;
            top: calc(-1rem - 1px);
            right: 0;
            left: 0;
        }
</style>
<script>
    export default {
        name: 'LabeledTextInput',

        props: {
            type: { type: String, default: 'text' },
            name: String,
            id: String,
            value: String,
            autocomplete: { type: String, default: 'off' },
            maxlength: String,
            required: Boolean,
            hasIcon: Boolean,
            rightSideIcon: Boolean,
        },

        computed: {
            inputValue() {
                return this.value
            },
            cssClasses() {
                return {
                    'labeled-text-input': 1,
                    ['input-type-' + this.type]: 1,
                    'has-icon': this.hasIcon,
                    'right-side-icon': this.rightSideIcon,
                    required: this.required,
                    filled: this.inputValue != '' && this.inputValue != undefined,
                }
            }
        },

        methods: {
            onValueChange(newVal) {
                //var newVal = val.replace(/[^0-9]/g, '');

                //this.inputValue = newVal;
                this.$emit('input', newVal);
            }
        },

        mounted() {
            this.$emit('update:ref', this.$refs.input);
        }
    }
</script>
